import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CourtDto } from "../../../models/court/dto/court.dto";
import { GET_COURT_QUERY_KEY } from "./useGetCourt";
import { GET_LOCATION_COURTS_QUERY_KEY } from "./useGetCourts";

export const useDuplicateCourt = (courtId: number, onSuccess: (data: CourtDto) => void) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => apiClient.fetchApi<CourtDto, {}>({
            endpoint: `courts/${courtId}/duplicate`,
            method: 'POST',
        }),
        onSuccess: (data: CourtDto) => {
            queryClient.setQueryData(GET_COURT_QUERY_KEY(data.id), () => data);
            queryClient.setQueryData(GET_LOCATION_COURTS_QUERY_KEY(data.location.id), (old: CourtDto[]) => [...old, data]);
            onSuccess(data);

        }
    });
};